export default __webpack_public_path__ + "static/media/MUANG_THAI_9960.eff99d2f.png";